module.exports = __webpack_public_path__ + "media/images/advertisement-5c4553d0a82315edfbf4d205d068696c.jpg";